

export const ADMIN_TOOL_BOOK_STATEMENT_STUDENT_LIST = 'ADMIN_TOOL_BOOK_STATEMENT_STUDENT_LIST';

export const ADMIN_TOOL_BOOK_STATEMENT_STUDENT_COURSE_LIST = 'ADMIN_TOOL_BOOK_STATEMENT_STUDENT_COURSE_LIST';



// WEBPACK FOOTER //
// ./src/store/Admin/modules/semesterStudentMoney/types.js